import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpStore } from '../../../stores/sign-up.store';
import { AuthLayout } from '../auth.layout';
import { Progress } from './progress';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { muiForm } from '@client/new/helpers/forms';
import { TextField, Typography } from '@mui/material';
import { trackEvent, track } from '@services/tracking';
import { instagramUsernameValidation } from '../../commonValidation';
import { trackSubmission } from '@services/hubspot/HubspotService';
import { isProduction } from '@client/components/auth';

const schema = z.object({
  profileInstagram: instagramUsernameValidation,
});

const hubspotForm = {
  formId: 'b1a307d8-c205-4b61-962c-80ddc54a9e03',
  portalId: '45090276',
};

export const FillInstagramStepPage = () => {
  const { setProfileInstagram, profileInstagram, email, firstName, lastName } =
    useSignUpStore();

  const { register, handleSubmit, watch } = muiForm(
    useForm({
      defaultValues: {
        profileInstagram,
      },
      resolver: zodResolver(schema),
    }),
  );

  const onSubmit = useCallback(async (values: { profileInstagram: string }) => {
    const instagramName = values.profileInstagram.trim().toLowerCase();
    track({ type: 'Instagram Submitted', payload: { uid: '' } });
    trackEvent({
      type: 'Instagram Submitted',
      payload: { instagramName } as any,
    });
    setProfileInstagram(instagramName);
    navigate(PATHS.SIGN_UP_CONFIRMATION_CODE);
    if (isProduction())
      trackSubmission({
        data: {
          email,
          instagram_handle: instagramName,
          firstname: firstName,
          lastname: lastName,
        },
        ...hubspotForm,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const complete = watch('profileInstagram')?.length;

  if (!email) {
    navigate(PATHS.SIGN_UP);
    return null;
  }

  return (
    <AuthLayout showGoBack title={'Help us get to know you 🌝'}>
      <div className="flex flex-col  w-full items-center">
        <Typography variant="body1" className="text-center mt-12">
          Help new members get to know you better by linking to your Instagram
          profile.
        </Typography>
        <form
          className="mt-8 w-full flex flex-col gap-3 text-left"
          onSubmit={handleSubmit(onSubmit)}
        >
          <TextField
            autoFocus
            aria-label="First name"
            type="text"
            label="Instagram handle"
            InputProps={{
              startAdornment: <span className="pr-1">@</span>,
              placeholder: 'Instagram.username',
            }}
            {...register('profileInstagram')}
          />
          <PrimaryButton
            large
            type="submit"
            className={`w-full mt-5`}
            disabled={!complete}
          >
            Continue
          </PrimaryButton>
        </form>

        <div className="absolute bottom-4">
          <Progress steps={2} stepsCompleted={2} />
        </div>
      </div>
    </AuthLayout>
  );
};
